import React from "react";
import virginLogo from "./assets/VirginLogo.png";
import deltaLogo from "./assets/DeltaLogo.png";
import sftaLogo from "./assets/SFTALogo.png";
import EARSLogo from "./assets/EARSLogo.png";
import blueprintLogo from "./assets/BlueprintLogo.png";
import blueprintWhiteLogo from "./assets/BlueprintWhiteLogo.png";
import afLogo from "./assets/AFLogo.png";
import BAXLogo from "./assets/BAXLogo.png";

import "./Logo.scss";

const Logo = ({ client, logoUrl, from, hideDefault = false }) => {
  const center =
    logoUrl?.includes("Partners") || client === "airfrance" || null;
  const longer =
    logoUrl?.includes("FabFour") ||
    logoUrl?.includes("Partners") ||
    logoUrl?.includes("DLAFKL") ||
    null;

  const clientLogo = logoUrl
    ? logoUrl
    : client === "virgin"
    ? virginLogo
    : client === "delta"
    ? deltaLogo
    : (client || "").toLowerCase() === "sfta"
    ? sftaLogo
    : (client || "").toLowerCase() === "ucb"
    ? EARSLogo
    : (client || "").toLowerCase() === "airfrance"
    ? afLogo
    : (client || "").toLowerCase() === "azbax"
    ? BAXLogo
    : from === "game"
    ? blueprintWhiteLogo
    : blueprintLogo;

  return (
    <div
      className={`Logo ${center ? "center" : longer ? "longer" : ""} ${client}`}
      style={from === "landing" ? { justifyContent: "center" } : {}}
    >
      {!hideDefault || logoUrl ? (
        <img alt="Client Logo" src={clientLogo} key={clientLogo} />
      ) : null}
    </div>
  );
};

export default Logo;
